var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { LocationType } from '@/common/types/LocationType';
import CheckBoxListRow from '@/common/components/CheckBoxListRow.vue';
import RadioButtonOptionRow from '@/common/components/RadioButtonOptionRow.vue';
import MunicipalitiesControl from '@/common/components/MunicipalitiesControl.vue';
import RegionsControl from '@/common/components/RegionsControl.vue';
import WellbeingServiceCountiesControl from '@/common/components/WellbeingServiceCountiesControl.vue';
import { Channel } from '@/common/types/Channel';
import { Location } from '@/common/types/Location';
var LocationControl = /** @class */ (function (_super) {
    __extends(LocationControl, _super);
    function LocationControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radioButtonValueChanged = "";
        return _this;
    }
    Object.defineProperty(LocationControl.prototype, "locationOptions", {
        get: function () {
            var options = [
                { id: LocationType.Municipality, name: "AidApplication.BasicInfo.Location.Selection.Municipality", confirmRadioClean: this.cleanSelected },
                this.allowRegionOption ? { id: LocationType.Region, name: "AidApplication.BasicInfo.Location.Selection.Region", confirmRadioClean: this.cleanSelected } : null,
                { id: LocationType.Abroad, name: this.jsonPrefix + ".BasicInfo.Location.Selection.Abroad", confirmRadioClean: this.cleanSelected },
                { id: LocationType.Nationwide, name: this.jsonPrefix + ".BasicInfo.Location.Selection.Nationwide", confirmRadioClean: this.cleanSelected },
                { id: LocationType.WellbeingServiceCounty, name: this.jsonPrefix + ".BasicInfo.Location.Selection.WellbeingServiceCounty", confirmRadioClean: this.cleanSelected }
            ];
            return options.filter(function (x) { return x !== null; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "channelOptions", {
        get: function () {
            return [
                { id: Channel.Phone, name: "AidApplication.BasicInfo.Channel.Selection.Phone" },
                { id: Channel.Online, name: "AidApplication.BasicInfo.Channel.Selection.Online" },
                { id: Channel.Chat, name: "AidApplication.BasicInfo.Channel.Selection.Chat" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "jsonPrefix", {
        get: function () {
            return this.summaryReport ? "SummaryReport" : "AidApplication";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "locationTitle", {
        get: function () {
            return this.jsonPrefix + ".BasicInfo.Location.Title";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "municipalitiesTitle", {
        get: function () {
            return this.jsonPrefix + ".BasicInfo.Municipalities.Title";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "regionsTitle", {
        get: function () {
            return this.jsonPrefix + ".BasicInfo.Regions.Title";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "wellbeingServiceCountiesTitle", {
        get: function () {
            return this.jsonPrefix + ".BasicInfo.WellbeingServiceCounties.Title";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "confirmMunicipalitiesStr", {
        get: function () {
            return this.summaryReport ? "SummaryReport.Confirm.Municipalities" : "AidApplication.Confirm.Delete.Municipalities";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "confirmRegionsStr", {
        get: function () {
            return this.summaryReport ? "SummaryReport.Confirm.Regions" : "AidApplication.Confirm.Delete.Regions";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "confirmWellbeingServiceCountiesStr", {
        get: function () {
            return "AidApplication.Confirm.Delete.WellbeingServiceCounties";
        },
        enumerable: false,
        configurable: true
    });
    LocationControl.prototype.cleanSelected = function (current) {
        if (current == LocationType.Municipality) {
            if (this.location.municipalities.length > 0) {
                if (confirm(this.$i18n.t(this.confirmMunicipalitiesStr).toString())) {
                    this.location.municipalities = [];
                    this.radioButtonValueChanged = Date();
                    return true;
                }
                this.location.locationType[0] = current;
                this.radioButtonValueChanged = Date();
                return false;
            }
        }
        else if (current == LocationType.Region) {
            if (this.location.regions.length > 0) {
                if (confirm(this.$i18n.t(this.confirmRegionsStr).toString())) {
                    this.location.regions = [];
                    this.radioButtonValueChanged = Date();
                    return true;
                }
                this.location.locationType[0] = current;
                this.radioButtonValueChanged = Date();
                return false;
            }
        }
        else if (current == LocationType.WellbeingServiceCounty) {
            if (confirm(this.$i18n.t(this.confirmWellbeingServiceCountiesStr).toString())) {
                this.location.wellbeingServiceCounties = [];
                this.radioButtonValueChanged = Date();
                return true;
            }
            this.location.locationType[0] = current;
            this.radioButtonValueChanged = Date();
            return false;
        }
        return true;
    };
    Object.defineProperty(LocationControl.prototype, "locationType", {
        get: function () {
            return this.location.locationType[0];
        },
        set: function (value) {
            this.location.locationType[0] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "showMunicipalities", {
        get: function () {
            return this.locationType == LocationType.Municipality;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "showRegions", {
        get: function () {
            return this.locationType == LocationType.Region;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocationControl.prototype, "showWellbeingServiceCounties", {
        get: function () {
            return this.locationType == LocationType.WellbeingServiceCounty;
        },
        enumerable: false,
        configurable: true
    });
    LocationControl.prototype.onPropertyChanged = function () {
        if (!this.showMunicipalities) {
            this.location.municipalities = [];
        }
        if (!this.showRegions) {
            this.location.regions = [];
        }
        if (!this.showWellbeingServiceCounties) {
            this.location.wellbeingServiceCounties = [];
        }
    };
    var _a;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof Location !== "undefined" && Location) === "function" ? _a : Object)
    ], LocationControl.prototype, "location", void 0);
    __decorate([
        Prop({ type: Boolean, required: true }),
        __metadata("design:type", Boolean)
    ], LocationControl.prototype, "showChannels", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LocationControl.prototype, "summaryReport", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LocationControl.prototype, "allowRegionOption", void 0);
    __decorate([
        Watch("location.locationType"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LocationControl.prototype, "onPropertyChanged", null);
    LocationControl = __decorate([
        Component({
            name: "LocationControl",
            components: {
                CheckBoxListRow: CheckBoxListRow,
                MunicipalitiesControl: MunicipalitiesControl,
                RegionsControl: RegionsControl,
                WellbeingServiceCountiesControl: WellbeingServiceCountiesControl,
                RadioButtonOptionRow: RadioButtonOptionRow
            }
        })
    ], LocationControl);
    return LocationControl;
}(Vue));
export default LocationControl;
